import { render, staticRenderFns } from "./ClosestEvent.vue?vue&type=template&id=4f834f09&"
import script from "./ClosestEvent.vue?vue&type=script&lang=js&"
export * from "./ClosestEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports